import React, { useState, useRef, useEffect } from "react";
import Styles from "./HomePage.module.css";
import { useNavigate } from "react-router-dom";
import realmeimg from "../../assets/Realmeunit.png";
import { Camera } from "lucide-react";

function HomePage(props) {
  const videoRef = useRef(null);
  const navigation = useNavigate();

  useEffect(() => {
    startCamera(); // Start the camera when the component mounts

    // Clean up the video stream when the component unmounts
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoRef.current.srcObject = stream;
      videoRef.current
        .play()
        .catch((error) => console.error("Error playing video:", error));

      videoRef.current.width = videoRef.current.videoWidth;
      videoRef.current.height = videoRef.current.videoHeight;
      videoRef.current.style.transform = "scaleX(-1)";
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  // const captureImage = () => {
  //   if (videoRef.current && videoRef.current.readyState === 4) {
  //     const canvas = document.createElement('canvas');
  //     const aspectRatio = videoRef.current.videoWidth / videoRef.current.videoHeight;
  //     const targetWidth = 800; // Adjust this value as needed

  //     canvas.width = targetWidth;
  //     canvas.height = targetWidth / aspectRatio;

  // const ctx = canvas.getContext('2d');
  // ctx.scale(-1, 1);
  // ctx.drawImage(videoRef.current, -canvas.width, 0, canvas.width, canvas.height);
  // ctx.restore();

  //     const image = canvas.toDataURL('image/jpeg');
  //     props.image(image);
  //     navigation('/userinput');
  //   } else {
  //     console.warn('Camera stream not ready yet.');
  //   }
  // };

  const captureImage = () => {
    if (videoRef.current && videoRef.current.readyState === 4) {
      const canvas = document.createElement("canvas");
      const aspectRatio =
        videoRef.current.videoWidth / videoRef.current.videoHeight;
      const targetWidth = 800; // Adjust this value as needed

      canvas.width = targetWidth;
      canvas.height = targetWidth / aspectRatio;

      const ctx = canvas.getContext("2d");
      ctx.scale(-1, 1);
      ctx.drawImage(
        videoRef.current,
        -canvas.width,
        0,
        canvas.width,
        canvas.height
      );
      ctx.restore();

      const image = canvas.toDataURL("image/jpeg");
      props.image(image);
      navigation("/userinput");
    } else {
      console.warn("Camera stream not ready yet.");
    }
  };

  return (
    <div className={`${Styles.main_container}`}>
      <div className={`${Styles.video_div}`}>
        <video
          ref={videoRef}
          id="camera"
          autoPlay
          playsInline
          className={`${Styles.camera_feed}`}
        ></video>
        <div className={`${Styles.camera_overlay}`} />
      </div>
      {/* <button
        className={`${Styles.capture_button}`}
        onClick={captureImage}
      ></button> */}
      <div
        onClick={captureImage}
        className={`${Styles.capture_button} hover:cursor-pointer bg-gradient-to-r from-[#0077b6] to-[#00b4d8] shadow-[0_4px_10px_rgba(0,119,182,0.3)]
`}
      >
        <Camera size={40} color="white" />
      </div>
    </div>
  );
}

export default HomePage;
